<app-system-icon *ngIf="sortOrder === 0" iconName="sort" iconType="outline"></app-system-icon>
<app-system-icon *ngIf="sortOrder === 1" iconName="arrow-up" iconType="outline"></app-system-icon>
<app-system-icon *ngIf="sortOrder === -1" iconName="arrow-down" iconType="outline"></app-system-icon>
